export default {"src":"/_next/static/media/file-check.e7cbecbe.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};